import React, { useEffect, useState } from 'react';

import { ReactComponent as ArrowRight } from '../../assets/icons/ubr_arrow_right.svg';
import { Box, DelayLink, Img, Layout, Shimmer } from '../../components';
import { useAuth } from '../../hooks/useAuth';
import { CardGrid, TitleContent, Title, SubTitle } from './styles';

interface CardProps {
  icone: string;
  id: string;
  subtitulo: string;
  titulo: string;
  url: string;
}

export const App: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { user } = useAuth();

  useEffect(() => {
    user?.telas?.sort((a: any, b: any) => {
      if (a.titulo < b.titulo) {
        return -1;
      }
      if (a.titulo > b.titulo) {
        return 1;
      }
      return 0;
    });
    setTimeout(() => {
      setIsLoading(false);
    }, 1200);
  }, []);

  const renderCards = (card: CardProps, index: number) => {
    return (
      <DelayLink key={index} to={card.url} data-testid={'card-test'}>
        <Box>
          <div>
            <figure>
              <Img src={card.icone} alt={card.titulo} />
            </figure>
          </div>

          <div className="main-card">
            <section>
              <h3>{card.titulo}</h3>
              <p>{card.subtitulo}</p>
            </section>

            <footer>
              <span>Acessar</span>
              <ArrowRight />
            </footer>
          </div>
        </Box>
      </DelayLink>
    );
  };

  const loaderCards = () => {
    return (
      <DelayLink to={'#'}>
        <Box>
          <div>
            <figure
              style={{
                border: '1px solid #eceeef',
              }}
            >
              <Shimmer height={'60px'} />
            </figure>
          </div>
          <div className="main-card">
            <section>
              <Shimmer height={'20px'} />
              <Shimmer height={'20px'} />
            </section>
            <footer>
              <Shimmer height={'30px'} width={'150px'} />
            </footer>
          </div>
        </Box>
      </DelayLink>
    );
  };

  return (
    <Layout hideFooter hideBackbar hideFloatingButton hideInstructionModal>
      <>
        {isLoading ? (
          <div data-testid={'loading'}>
            <TitleContent>
              <Shimmer width={'70%'} height={'40px'} />
              <Shimmer width={'100%'} height={'30px'} />
            </TitleContent>
            <CardGrid>
              {loaderCards()}
              {loaderCards()}
              {loaderCards()}
            </CardGrid>
          </div>
        ) : (
          <>
            <TitleContent>
              <Title data-testid="title-test">
                Bem vindo ao portal de homologação da Unicred
              </Title>
              <SubTitle data-testid="subtitle-test">
                {user?.roles[0] === 'CONVENIO'
                  ? `Esse portal visa homologar o sistema escolhido por você para débito automático, junto a Unicred.`
                  : `Este portal visa homologar o sistema escolhido por você para
                emissão de boletos, junto a Unicred.`}
              </SubTitle>
            </TitleContent>

            <CardGrid>{user?.telas?.map(renderCards)}</CardGrid>
          </>
        )}
      </>
    </Layout>
  );
};
